import React from 'react';

const ExecutivePresence = () => {
  return (
    <div data-aos="fade-up" className="lg:px-16 p-4 bg-gradient-to-r from-gray-100 to-white rounded-lg  ">
      <div className="lg:flex lg:justify-between items-center">
        {/* Text Section */}
        <div className="lg:w-[45%] bg-white border border-gray-300 rounded-lg shadow-lg lg:p-8 p-6 mb-4 lg:mb-0">
          <h1 className="text-blue-600 font-bold text-center lg:text-4xl text-3xl mb-4"  style={{ fontFamily: "Helvetica" }} >What is Executive Presence?</h1>
          <blockquote  style={{ fontFamily: "Poppins" }} className="text-gray-900 lg:text-2xl font-normal text-lg text-justify pb-3">
            Executive Presence is the impact you create on your ecosystem when you rediscover your greatness within.
            <p className="flex justify-end font-bold">— Kshitij Sharma</p>
          </blockquote>

        {/* </p> */}
      </div>

      {/* Image Section */}
      <div data-aos="fade-up" className="lg:w-[50%] ">
        <img
          src="https://imageio.forbes.com/specials-images/imageserve/65c135677e06477e51d9bb5b/Male-CEO-Standing-in-Front-of-a-Large-Group-of-Business-People/960x0.jpg?format=jpg&width=1440"
          alt="Three people sitting at a table with laptops, smiling and having a discussion"
          className="rounded-lg shadow-md w-full h-auto max-h-[400px] object-cover "
        />
      </div>
    </div>

      {/* Additional Info Section */ }
      
    </div >
  );
};

export default ExecutivePresence;
